import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { organizationEntityToModel } from 'shared/domain/organization/mapping/toModel';
import { OrganizationInDto } from 'shared/domain/organization/types/dto';
import { OrganizationModel } from 'shared/domain/organization/types/model';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import * as dbOrganizations from '../../db/organizations/organizations';
import { broadcastUploadedOrganizationError } from './error';
import { organizationContract } from 'shared/domain/organization/organizationContract';
import { makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

/**
 * Answers a change with the organization the HTTP queue stored, as a model;
 * a failure to read it rejects the change instead.
 */
function makeStoredOrganizationBroadcast(
  type: DomainMessagesTypes.createdEntity | DomainMessagesTypes.updatedEntity
) {
  const broadcastModel = makeEventPublisher(organizationContract, type);

  return async (organizationInDto: OrganizationInDto, uniqueId: string): Promise<void> => {
    try {
      const organizationEntity = await dbOrganizations.getOne(organizationInDto._id);
      if (!organizationEntity) {
        throw new Error(`Cannot find organization with id ${organizationInDto._id}`);
      }
      broadcastModel(organizationEntityToModel(organizationEntity), uniqueId);
    } catch (error) {
      broadcastUploadedOrganizationError(error, chooseErrorMessage(error), uniqueId);
    }
  };
}

export const broadcastCreatedOrganization = makeStoredOrganizationBroadcast(
  DomainMessagesTypes.createdEntity
);

export const broadcastUpdatedOrganization = makeStoredOrganizationBroadcast(
  DomainMessagesTypes.updatedEntity
);
